export default __webpack_public_path__ + "static/media/Consensys_NFT_logo_filled.ae4a5065.svg";